import { render, staticRenderFns } from "./HeaderAndContent.vue?vue&type=template&id=34b29a2c"
import script from "./HeaderAndContent.vue?vue&type=script&lang=js"
export * from "./HeaderAndContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports